import {TimingUnit} from "@/pages/maintenance/maintenance-create/tabs/notifications/NotificationRow.types.ts";

export const offsetToTiming = (offsetSeconds: number): {amount: number; unit: TimingUnit} => {
  const isBefore = offsetSeconds <= 0;
  const absSeconds = Math.abs(offsetSeconds);

  if (absSeconds !== 0 && absSeconds % 86400 === 0) {
    return {
      amount: absSeconds / 86400,
      unit: isBefore ? TimingUnit.DAYS_BEFORE : TimingUnit.DAYS_AFTER,
    };
  }
  if (absSeconds !== 0 && absSeconds % 3600 === 0) {
    return {
      amount: absSeconds / 3600,
      unit: isBefore ? TimingUnit.HOURS_BEFORE : TimingUnit.HOURS_AFTER,
    };
  }
  return {
    amount: absSeconds / 60,
    unit: isBefore ? TimingUnit.MINUTES_BEFORE : TimingUnit.MINUTES_AFTER,
  };
};

export const timingToOffset = (amount: number, unit: TimingUnit): number => {
  const abs = Math.abs(amount);
  let seconds: number;
  switch (unit) {
    case TimingUnit.MINUTES_BEFORE:
    case TimingUnit.MINUTES_AFTER:
      seconds = abs * 60;
      break;
    case TimingUnit.HOURS_BEFORE:
    case TimingUnit.HOURS_AFTER:
      seconds = abs * 3600;
      break;
    case TimingUnit.DAYS_BEFORE:
    case TimingUnit.DAYS_AFTER:
      seconds = abs * 86400;
      break;
  }
  const isBefore = unit.endsWith("BEFORE");
  return isBefore ? -seconds : seconds;
};
